/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1OfacMatchEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_OFAC_MATCH_EVENT_ENTITY_NAME = 'ixf.watchlist.v1.OfacMatchEvent';
export const ixfWatchlistV1OfacMatchEventEntity = new schema.Entity<IxfWatchlistV1OfacMatchEvent>(IXF_WATCHLIST_V1_OFAC_MATCH_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfWatchlistV1OfacMatchEvent) => `${entity.metadata?.eventId}` });

